import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  root: {
    height: 60,
    borderBottom: '1px solid #E0E0E0',
    '&:hover': {
      backgroundColor: palette.background.selected,
      cursor: 'pointer'
    },
    '&:focus': {
      backgroundColor: palette.background.selected
    },
    pointerEvents: 'initial'
  },
  accountIcon: {
    color: '#666666',
    marginRight: spacing(2)
  },
  column: {
    padding: spacing(0, 2.5, 0, 3)
  },
  status: {
    color: ({ isActive }) => isActive ? palette.success.main : palette.grey.main
  }
}))
